import { defineMessages } from 'react-intl';

export const ErrorFallbackMessages = defineMessages({
  RequestError: {
    id: 'ic-errorFallback-message',
    defaultMessage:
      'Aus technischen Gründen ist die Berechnung der Rate momentan nicht möglich. Bitte lade die Seite erneut oder versuche es später noch einmal.',
  },
});
